"use strict";
/*
Example usage:

import { getIdToken, getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

const api = buildApi({
  // TODO: Fill these in with the actual endpoints
  fetchMap: {
    "artist.resolver": "",
    "artist.start": "",
    "search.streaming": "",
    "search.youtube": "",
  },
  getToken: async () => {
    const auth = getAuth();
    if (auth.currentUser) {
      return getIdToken(auth.currentUser);
    }

    console.warn(
      "An attempt is being made to call an API endpoint before we have an authenticated user",
    );

    return "";
  },
  httpsCallable: (name) => httpsCallable(getFunctions(), name),
});

api.call("setlivev3-analysis-analyzeImageFromURL", { url: "" }).then((res) => {
  res.data.colors;
});

api.call("artist.resolver", { url: "" }).then((res) => {
  if (res.data.success) {
    res.data.data.displayName;
  }
});
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApi = exports.ErrorCodes = void 0;
const base_1 = require("./base");
Object.defineProperty(exports, "ErrorCodes", { enumerable: true, get: function () { return base_1.ErrorCodes; } });
const buildApi = (props) => {
    const isFetchable = (key) => key in props.fetchMap;
    const call = async (name, body) => {
        if (isFetchable(name)) {
            const url = props.fetchMap[name];
            if (!url) {
                throw new Error(`API is missing route to endpoint ${name}`);
            }
            const token = await props.getToken().catch((error) => {
                console.warn("Error getting JWT for user", error);
            });
            const req = new Request(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: body !== undefined ? JSON.stringify(body) : "",
            });
            if (token) {
                req.headers.set("Authorization", `bearer ${token}`);
            }
            const data = await fetch(req)
                .then((res) => res.json())
                .then((data) => ({ data }));
            return data;
        }
        return (await props.httpsCallable(name)(body));
    };
    return { call };
};
exports.buildApi = buildApi;
//# sourceMappingURL=index.js.map